import styled, { css } from 'styled-components';
import { CarrouselFeaturedProps } from './CarrouselFeatured';

export const CarrouselWrapper = styled.div<CarrouselFeaturedProps>`
  ${({ theme, slidesPerView, minHeight, ...props }) => {
    return css`
      position: relative;
      .swiper {
        // This will make the Swiper container NOT cause a Layout Shift
        &:not(.swiper-initialized) {
          .swiper-wrapper {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            max-height: ${minHeight ? minHeight : '400px'};
            width: 100%;
            overflow: hidden;
            gap: ${theme.spacing.base};
          }

          @media screen and (min-width: ${theme.breakpoint.sm}) {
            .swiper-wrapper {
              grid-template-columns: repeat(${slidesPerView || 4}, 1fr);
              gap: ${theme.spacing.md};
            }
          }
        }
      }
    `;
  }};
`;
